import PopupComponent from '@components/std-components/Popup'
import React, { FC, useContext, lazy, Suspense } from 'react'
import OrderContext from '../../contexts/order-context'
import { useObserver } from 'mobx-react-lite'
import { OrderDetailsProps } from './OrderDetails'
import FallbackComponent from '@components/std-components/FallbackComponent'

const OrderDetailsLazy = lazy(() => import('./OrderDetails'))

export interface OrderDetailsPopupProps extends OrderDetailsProps {}

const OrderDetailsPopup: FC<OrderDetailsPopupProps> = ({ ...props }) => {
  return useObserver(function useHook() {
    const {
      uiStore: { isOrderDetailsModalOpen }
    } = useContext(OrderContext)
    return (
      <PopupComponent
        open={isOrderDetailsModalOpen}
        closeOnDocumentClick={false}
        nested={true}
        closeOnEscape={false}
        contentStyle={{ width: '75%' }}
      >
        <Suspense fallback={<FallbackComponent />}>
          <OrderDetailsLazy {...props} />
        </Suspense>
      </PopupComponent>
    )
  })
}

export default OrderDetailsPopup
